<script setup lang="ts">
import { RemainingCourse } from '@/type/Course'
import { format } from 'date-fns'
import { computed } from 'vue'
import { useTranslation } from 'i18next-vue'

const { t } = useTranslation()
const prop = defineProps<Props>()

interface Props {
  course: RemainingCourse
}

const endDateDisplay = computed(() => {
  if (prop.course.end_date && prop.course.end_date !== 'no_expire') {
    return format(new Date(prop.course.end_date), 'dd/MM/yyyy')
  }
  return t('course.no_expire')
})

const buyDateDisplay = computed(() => {
  if (prop.course.buy_date) {
    return format(new Date(prop.course.buy_date), 'dd/MM/yyyy')
  }
  return '-'
})
</script>

<template>
  <div class="tw-mb-3">
    <van-cell
      center
      is-link
      @click="$emit('click', course)"
      class="tw-mb-3 !tw-p-4"
    >
      <template #title>
        <div>
          <div class="tw-flex tw-items-center tw-gap-2">
            <img
              :src="course.icon_url"
              alt="course image"
              class="tw-w-8 tw-h-8 tw-rounded-xs"
            />
            <p>{{ course.course_name }}</p>
          </div>
          <div
            class="tw-grid tw-grid-cols-2 tw-items-center tw-gap-2 tw-text-xs tw-mt-3 tw-justify-between"
          >
            <!-- medicine -->
            <div class="tw-flex tw-items-center tw-gap-2">
              <i
                class="mdi mdi-pill tw-text-blue-600"
                style="font-size: 24px"
              ></i>
              {{ $t('course.medicine') }}:
              <p>{{ course.remaining_medicine_text || '-' }}</p>
            </div>

            <!-- service -->
            <div class="tw-flex tw-items-center tw-gap-2">
              <i
                class="mdi mdi-stethoscope tw-text-purple-600"
                style="font-size: 24px"
              ></i>
              <p>
                {{ $t('course.service') }}:

                {{ course.remaining_service_text || '-' }}
              </p>
            </div>
          </div>
          <div
            class="tw-grid tw-grid-cols-2 tw-items-center tw-gap-2 tw-text-xs tw-mt-3 tw-justify-between"
          >
            <!-- buy date -->
            <div class="tw-flex tw-items-center tw-gap-2">
              <i
                class="mdi mdi-calendar-blank tw-text-green-600"
                style="font-size: 24px"
              ></i>
              {{ $t('course.buy_date') }}:
              <p>{{ buyDateDisplay }}</p>
            </div>

            <!-- expire date -->
            <div class="tw-flex tw-items-center tw-gap-2">
              <i
                class="mdi mdi-clock tw-text-amber-500"
                style="font-size: 24px"
              ></i>
              <p>{{ $t('course.expire_date') }}: {{ endDateDisplay || '-' }}</p>
            </div>
          </div>
        </div>
      </template>
    </van-cell>
  </div>
</template>

<style scoped>
:deep(.van-cell) {
  padding: 16px;
  background: white;
  border-radius: 12px;
}
</style>
